import { Controller } from '@hotwired/stimulus';

export default class SubscriptionForecastController extends Controller {
  static targets = ['amount'];

  toggleAmount(event) {
    this.amountTarget.value = '';
    this.amountTarget.disabled = event.target.checked;
  }
}
